import { LocationTo, useHistory } from '@framework/ui';
import { Button, ButtonProps } from 'antd';
import * as React from 'react';
import { LinkProps } from 'react-router-dom';

export interface LinkButtonProps extends Omit<ButtonProps, 'onClick'> {
  to: LocationTo;
  /**
   * @deprecated le props di linkProps non vengono più utilizzate
   */
  linkProps?: Omit<LinkProps, 'to'>;
}

/**
 * Button con funzionalità del Link di react-router-dom
 */
export function LinkButton(props: LinkButtonProps) {
  const { to, linkProps, ...buttonProps } = props;
  const history = useHistory();

  const handleClick = () => {
    history.push(to);
  };

  return <Button role="link" {...buttonProps} onClick={handleClick} />;
}
